import React from "react"
import moment from "moment/moment"
import { useNavigate } from "react-router-dom"

const Footer = () => {
  const navigate = useNavigate()
  return (
    <>
      <div className="bg- primary p-2 h-14 text-center items-center flex justify-center text-xs">
        <span className="px-1">
          <span
            onClick={() => {
              navigate("/admin-vaishnavi")
            }}
          >
            ©
          </span>
          <span>
            {moment().format("YYYY")} by VAISHNAVI UCHIL. Powered and Created by
            91N WIZARDS
          </span>
        </span>
      </div>
    </>
  )
}

export default Footer
